import React from "react";
import { PageHeader } from "./Rentals";

export default function Privacy() {
  return (
    <div>
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="How IceFleet collects, uses, and protects customer information." />
      <section className="mx-auto max-w-4xl px-5 sm:px-8 pb-24 space-y-10 text-sm leading-7 text-slate-700">
        <LegalSection title="Information we collect">
          <p>We collect information submitted through booking, inquiry, and contact forms, including names, emails, phone numbers, service details, and operational notes needed to deliver transport, tours, and rentals.</p>
        </LegalSection>
        <LegalSection title="How we use your data">
          <p>We use booking and contact data to provide service quotes, confirm bookings, manage operations, send service emails, and support customer communication.</p>
        </LegalSection>
        <LegalSection title="Payment processing">
          <p>Rapyd, Stripe, and other payment providers may process payment information in connection with your booking. IceFleet does not store full card details directly in the website application.</p>
        </LegalSection>
        <LegalSection title="Third-party providers">
          <p>We may use third-party providers for payments, communications, hosting, analytics, and service operations. Microsoft 365 may be used for email communications.</p>
        </LegalSection>
        <LegalSection title="Cookies & analytics">
          <p>Basic analytics and technical cookies may be used to improve website performance, security, and customer experience.</p>
        </LegalSection>
        <LegalSection title="Privacy requests">
          <p>For privacy or data access requests, contact <a className="text-sky-700 underline" href="mailto:info@icefleet.is">info@icefleet.is</a>.</p>
        </LegalSection>
      </section>
    </div>
  );
}

function LegalSection({ title, children }) {
  return (
    <div className="space-y-3">
      <h2 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">{title}</h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}